module.exports = __webpack_public_path__ + "img/143093446467972_image.jpg";